export const MIN_FIRST_REGISTRATION_YEAR = 2012;
